import { render, staticRenderFns } from "./project-dropdown.vue?vue&type=template&id=4c5eb4a3"
import script from "./project-dropdown.vue?vue&type=script&lang=js"
export * from "./project-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports